import React, {FC} from 'react';
import {Text} from 'components-lib';
interface IFooterTextProps {
  footerText: string;
}

export const FooterText: FC<IFooterTextProps> = ({footerText}) => {
  return <Text.Paragraph>{footerText}</Text.Paragraph>;
};
